import Vue from 'vue';
import Router from 'vue-router';
import diff from 'lodash.difference';
import api from '@/api';
import views from './views';
import { isSuperuser } from './helpers/authentication';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', redirect: { name: 'businesses' } },
    { path: '/login', name: 'login', component: views.Login },
    { path: '/businesses', name: 'businesses', component: views.businesses.Index },
    { path: '/businesses/new', name: 'new-business', component: views.businesses.New },
    { path: '/businesses/:id/edit', name: 'edit-business', component: views.businesses.Edit },
    { path: '/businesses/:id', name: 'business', component: views.businesses.Show },
    { path: '/sessions', name: 'sessions', component: views.sessions.Index },
    { path: '/sessions/new', name: 'new-session', component: views.sessions.New },
    { path: '/sessions/:id/edit', name: 'edit-session', component: views.sessions.Edit },
    { path: '/sessions/:id', name: 'session', component: views.sessions.Show },
    { path: '/protocols', name: 'protocols', component: views.protocols.Index },
    { path: '/protocols/:id/:type', name: 'show-protocol', component: views.protocols.Show },
    { path: '/protocols/:id/:type/edit', name: 'edit-protocol', component: views.protocols.Edit },
    { path: '/protocols/new', name: 'new-protocol', component: views.protocols.New },
    { path: '/404', name: '404', component: views.NotFound },
    { path: '*', component: views.NotFound },
  ],
});

router.beforeEach(async (to, from, next) => {
  const matched = router.getMatchedComponents(to);
  const prevMatched = router.getMatchedComponents(from);

  // As we're routing through the Shell component,
  // we always have the component we want (e.g. Committee.vue)
  // at the last positon of the matched
  const component = matched[matched.length - 1];

  // If there's a diffrence between the previous matched
  // and the matched, it's a route change. (/foo/1 -> /bar/2)
  const activated = diff(matched, prevMatched);
  const routeChanged = !!activated.length;

  if (component.requireSuperuser && !isSuperuser()) {
    return next({ name: 'login', query: { to: to.fullPath } });
  }

  if (routeChanged && component.initialAsyncData) {
    await component.initialAsyncData(to.params);
  }

  if (component.asyncData) {
    await component.asyncData(to.params);
  }

  return next();
});

api.interceptors.response.use(response => response, (error) => {
  if (error.response.status === 404 && error.config.method === 'get') {
    router.push({ name: '404' });
  }
  return Promise.reject(error);
});

export default router;
